export const tableData = [{
    name:"标签1",
    searchCount:10,
    status:"可用",
    isComment:"否"
},{
    name:"标签1",
    searchCount:10,
    status:"可用",
    isComment:"否"
},{
    name:"标签1",
    searchCount:10,
    status:"可用",
    isComment:"否"
},{
    name:"标签1",
    searchCount:10,
    status:"可用",
    isComment:"否"
},{
    name:"标签1",
    searchCount:10,
    status:"可用",
    isComment:"否"
}];